import { useState } from 'react'
import searchIcon from './icons/search.png';
import { Link, useNavigate } from "react-router-dom"


function Searchbar() {
  const [text, setText] = useState('')
  let navigate = useNavigate()
  return (
    <div className='flex mt-4  md:mt-0 '>
      <input type='text' className='h-8 w-[95vw]  text-black px-2 md:w-[15vw] lg:w-[25vw] rounded-s-md' value={text} placeholder='Search Movies...🍿 ' onChange={

        (e) => {
          if (e.Key == 'Enter') {
            Search()
          }
          else {
          } setText(e.target.value)

        }

      }

        onKeyDown={(e) => { if (e.key == 'Enter') { navigate("/search/" + text) } }} >

      </input>
      <Link to={`/search/${text}`}>

        <div className='w-8 h-8 rounded-r-md bg-pink-600 text-white flex items-center justify-center fill-[white]'>
          <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
            <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" /></svg>
        </div>
      </Link>
    </div>
  )
}

export default Searchbar